import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b40f15a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40f15a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b40f15a')) {
      api.createRecord('0b40f15a', component.options)
    } else {
      api.reload('0b40f15a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b40f15a&scoped=true", function () {
      api.rerender('0b40f15a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/pageList/index.vue"
export default component.exports